import React from "react";
import ExploreDoctorCard from "./ExploreDoctorCard";

export default function ExploreDoctorList({
  doctors = [],
  onOpenProfile,
  onBook,
}) {
  if (!doctors.length) {
    return (
      <div className="p2-explore-empty">
        Nuk u gjet asnjë mjek me këto kritere. Provo një kërkim tjetër
        ose ndrysho filtrat.
      </div>
    );
  }

  return (
    <div className="p2-explore-list">
      {doctors.map((d) => (
        <ExploreDoctorCard
          key={d.id}
          doctor={d}
          onOpenProfile={onOpenProfile}
          onBook={onBook}
        />
      ))}
    </div>
  );
}
